import type { IAdminStatsTotals } from '@/entities/admin-stats.entity';
import { formatProfitUsd } from '@/lib/format-profit';
import { BoxIcon, DollarSignIcon, UsersIcon, WifiIcon } from 'lucide-react';
import SummaryCards from './summary-cards';

interface AdminSummaryCardsProps {
	totals: IAdminStatsTotals;
}

export default function AdminSummaryCards({ totals }: AdminSummaryCardsProps) {
	return (
		<SummaryCards
			cards={[
				{ icon: UsersIcon, label: 'Клиенты', value: totals.clients.toLocaleString('ru-RU'), color: 'text-chart-2' },
				{ icon: WifiIcon, label: 'Онлайн', value: totals.onlineClients.toLocaleString('ru-RU'), color: 'text-chart-2' },
				{ icon: DollarSignIcon, label: 'Профит', value: `$${formatProfitUsd(totals.profits)}`, color: 'text-chart-5' },
				{ icon: BoxIcon, label: 'Билды', value: totals.builds.toLocaleString('ru-RU'), color: 'text-foreground' },
			]}
		/>
	);
}
